import React, { Key, useState } from 'react';
import { Radio, Space, theme } from 'antd';
import { useDispatch } from 'react-redux';
import { gapsOp } from 'store/ducks/Gaps';
import { clientReqOp } from 'store/ducks/ClientReq';
import {
  IFilterDropdownProps,
  IOptionnesTable
} from 'store/ducks/Global/types';
import * as Styled from './FilterDropdown.styled';

const { useToken } = theme;

export const FilterDropdown: React.FC<IFilterDropdownProps> = ({
  setSelectedKeys,
  selectedKeys,
  confirm,
  options,
  defaultValue,
  filterName
}) => {
  const dispatch = useDispatch();
  const { token } = useToken();
  const [selectedFilterValue, setSelectedFilterValue] = useState<string>(
    defaultValue as string
  );

  const handleFilterChange = (e: any) => {
    const value = e.target.value;
    setSelectedFilterValue(value);
  };

  return (
    <Styled.StyledMainDiv token={token} onKeyDown={(e) => e.stopPropagation()}>
      <Radio.Group onChange={handleFilterChange} value={selectedFilterValue}>
        <Space direction='vertical'>
          {options.map((option: IOptionnesTable) => (
            <Radio key={option.value} value={option.value}>
              {option.text}
            </Radio>
          ))}
        </Space>
      </Radio.Group>
      <Styled.StyledDiv token={token}>
        <Styled.StyledButton
          type='primary'
          size='small'
          onClick={() => {
            confirm({ closeDropdown: true });
            filterName === 'gapNoticed'
              ? dispatch(
                  gapsOp.setTableFilter({ [filterName]: [selectedFilterValue] })
                )
              : dispatch(
                  clientReqOp.setTableFilter({
                    [filterName]: [selectedFilterValue]
                  })
                );
          }}
        >
          OK
        </Styled.StyledButton>
      </Styled.StyledDiv>
    </Styled.StyledMainDiv>
  );
};
